import { ChangeEvent, Dispatch } from 'react';
import { CohortMetadata } from 'schemas/metadata/cohorts.ts';
import { RuleEditor } from 'schemas/IterationRule.schema';
import { DefaultEditor } from 'components/forms/Rule/Editors/DefaultEditor';
import { IRuleState, RuleActions } from 'reducers/rule/ruleReducer';
import { ActionTypes } from 'components/forms/Rule/Editors/ActionTypes.ts';
import { TextEditor } from 'components/forms/Rule/Editors/TextEditor';
import { ListEditor } from 'components/forms/Rule/Editors/ListEditor';
import { TextAndDateEditor } from 'components/forms/Rule/Editors/TextAndDateEditor';
import { RadiosEditor } from 'components/forms/Rule/Editors/RadiosEditor';
import { PickListEditor } from 'components/forms/Rule/Editors/PickListEditor';
import { DateEditor } from 'components/forms/Rule/Editors/DateEditor';

interface EditorSelectorProps {
  ruleEditor: RuleEditor | undefined,
  ruleState: IRuleState;
  errors: Record<string, string>;
  dispatch: Dispatch<RuleActions>;
  deriveDisplayName: (attributeName: string) => string;
  setOperator: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleTextChange: (e: ChangeEvent<HTMLInputElement>, actionType: ActionTypes) => void;
  isComparatorRequired: () => boolean;
  teamCohorts: CohortMetadata[];
}

function EditorSelector({
  ruleEditor,
  ruleState,
  errors,
  dispatch,
  deriveDisplayName,
  setOperator,
  handleTextChange,
  isComparatorRequired,
  teamCohorts,
}: EditorSelectorProps) {
  if (!ruleEditor) {
    return (
      <DefaultEditor
        ruleState={ruleState}
        dispatch={dispatch}
        deriveDisplayName={deriveDisplayName}
        setOperator={setOperator}
        handleTextChange={handleTextChange}
        errors={errors}
        isComparatorRequired={isComparatorRequired}
        teamCohorts={teamCohorts}
      />
    );
  }

  switch (ruleEditor.Type) {
    case 'TEXT':
      return (
        <TextEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          conditionType={ruleState.selectedConditionType}
          errors={errors}
        />
      );

    case 'TEXT_AND_DATE':
      return (
        <TextAndDateEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          errors={errors}
        />
      );

    case 'LIST':
      return (
        <ListEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          errors={errors}
        />
      );

    case 'RADIOS':
      return (
        <RadiosEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          conditionType={ruleState.selectedConditionType}
          errors={errors}
        />
      );

    case 'PICK_LIST':
      return (
        <PickListEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          errors={errors}
        />
      );

    case 'DATE':
      return (
        <DateEditor
          ruleEditor={ruleEditor}
          dispatch={dispatch}
          value={ruleState.selectedComparator}
          conditionType={ruleState.selectedConditionType}
          errors={errors}
        />
      );

    default:
      return (
        <p>
          No editor available for
          {ruleEditor?.Type}
        </p>
      );
  }
}

export default EditorSelector;
